
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 20 20","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M15.114 19.375v-12.5m-9.819 0v12.5m9.819-3.75h3.068a.62.62 0 00.613-.625V5.625c0-2.76-2.198-5-4.909-5H12.66c0 1.38-1.099 2.5-2.454 2.5-1.356 0-2.455-1.12-2.455-2.5H6.523c-2.71 0-4.91 2.24-4.91 5V15a.62.62 0 00.614.625h3.068m0-6.25h9.819m-9.819 2.5h9.819m-9.819 2.5h9.819","stroke":"currentColor","stroke-width":"1.25","fill":"none","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    